import axios from 'axios';

export default {
  namespaced: true,

  state: {
    authenticated: false,
    userLicence: null,
    currentOs: null,
    client: null,
    isTestAccountRegistered: null,
    isTestAccountUnregistered: null,
    hasCourseAccess: null,
    orderQuery: null,
    wasTransferredToSkp: null,
    cloudNeverHave2024: true,
  },
  getters: {
    authenticated(state) {
      return state.authenticated;
    },
    userLicence(state) {
      return state.userLicence;
    },
    userLicenceStorage() {
      return localStorage.getItem('userLicence');
    },
    currentOs(state) {
      return state.currentOs;
    },
    wasTransferredToSkp(state) {
      return state.wasTransferredToSkp;
    },
    cloudNeverHave2024(state) {
      return state.cloudNeverHave2024;
    },
    client(state) {
      return state.client;
    },
    isTestAccountRegistered(state) {
      return state.isTestAccountRegistered;
    },
    isTestAccountunRegistered(state) {
      return state.isTestAccountUnregistered;
    },
    hasCourseAccess(state) {
      return state.hasCourseAccess;
    },
    getOrderQuery(state) {
      return state.orderQuery;
    },
  },
  mutations: {
    SET_AUTHENTICATED(state, value) {
      state.authenticated = value;
    },
    SET_USERLICENCE(state, value) {
      localStorage.setItem('userLicence', value);
      state.userLicence = value;
    },
    SET_CURRENTOS(state, value) {
      state.currentOs = value;
    },
    SET_CLOUD_NEVER_HAVE_2024(state, value) {
      state.cloudNeverHave2024 = value;
    },
    SET_IFWASTRANSFERREDTOSKP(state, value) {
      state.wasTransferredToSkp = value;
    },
    SET_CLIENT(state, value) {
      state.client = value;
    },
    SET_IS_TEST_ACCOUNT_REGISTERED(state, value) {
      state.isTestAccountRegistered = value;
    },
    SET_IS_TEST_ACCOUNT_UNREGISTERED(state, value) {
      state.isTestAccountUnregistered = value;
    },
    SET_HAS_COURSE_ACCESS(state, value) {
      state.hasCourseAccess = value;
    },
    setOrderQuery(state, value) {
      state.orderQuery = value;
    },
  },
  actions: {
    async signIn({ dispatch }, credentials) {
      try {
        await axios.get('/sanctum/csrf-cookie');
        await axios.post('/login', credentials);

        return dispatch('me');
      } catch (error) {
        throw new Error('Nieprawidłowe dane użytkownika.');
      }
    },

    async signOut({ dispatch }, program) {
      localStorage.removeItem('staffName');
      localStorage.removeItem('staffId');

      await axios.post('/logout', { program: program });

      return dispatch('me');
    },

    me({ commit }) {
      let userLicence = this.state.userLicence;
      return axios
        .get('/api/user/')
        .then((response) => {
          commit('SET_AUTHENTICATED', true);
          commit('SET_USERLICENCE', response.data.licence);
          commit('SET_CURRENTOS', response.data.currentOs);
          commit('SET_CLOUD_NEVER_HAVE_2024', response.data.cloudNeverHave2024);
          commit(
            'SET_IFWASTRANSFERREDTOSKP',
            response.data.wasTransferredToSkp
          );
          commit('SET_CLIENT', response.data.userable);
          commit(
            'SET_IS_TEST_ACCOUNT_REGISTERED',
            response.data.isTestAccountRegistered
          );
          commit(
            'SET_IS_TEST_ACCOUNT_UNREGISTERED',
            response.data.isTestAccountUnregistered
          );
          commit('SET_HAS_COURSE_ACCESS', response.data.hasAccountingCourse);
          if (userLicence !== null && userLicence !== response.data.licence) {
            return window.location.reload(true);
          }
        })
        .catch(() => {
          commit('SET_AUTHENTICATED', false);
          commit('SET_USERLICENCE', null);
          commit('setOrderQuery', null);
        });
    },
  },
};
